import alt from '../alt';

import {getLoginRedirectUrl} from '../utils/authViewHelpers';
import SingleObjectResource from '../resources/GenericResource';


class CurrentUserActions {
    constructor() {
        this.generateActions(
            'receivedCurrentUser', 'failedCurrentUser', 'logout', 'changeUserForgottenPassword', 'mergeErrorsIntoState',
            'activateUserFail', 'clearUserDataReceived'
        );
    }

    updateUser(user) {
        new SingleObjectResource(DJ_CONST.API.apiUserDetails).patch({}, user).then(result => {
            this.dispatch(user);
        }).catch(err => this.actions.failUpdateUser(err));
    }

    failUpdateUser(updateError) {
        if (updateError.statusCode === 400){
            this.dispatch({updateError});
        } else {
            return CurrentUserActions.pageFault(updateError);
        }
    }

    pageFault(pageFault) {
        this.dispatch({pageFault});
    }

    didLogin() {
        // Force a redirect on login since it re-renders most of the page
        const newPath = getLoginRedirectUrl();
        // Chrome will ignore it if location is the same
        if (window.location !== newPath) {
            window.location = newPath;
        } else {
            window.location.reload();
        }
    }

    failLogin(loginError) {
        this.dispatch({loginError});
    }

    passwordResetSuccess() {
        const confirm_success = confirm("Password reset successful!");
        if  (confirm_success) {
            const newPath = '/';
            window.location = newPath;
        }
    }

    sentResetPasswordMail() {
        alert('E-mail successfully sent!');
    }

    failResetPassword(retrievePasswordError) {
        this.dispatch({retrievePasswordError});
    }

    failResetPasswordEmail(resetEmailError) {
        this.dispatch({resetEmailError})
    }

    didRegister() {
        // Force a redirect on register since it re-renders most of the page
        const newPath = '/?action=true';
        // Chrome will ignore it if location is the same
        if (window.location !== newPath) {
            window.location = newPath;
        } else {
            window.location.reload();
        }
    }

    sendActivationEmail(email) {
        new SingleObjectResource(DJ_CONST.API.apiSignup).post(null, {'re-send': true, 'email': email}).then(() => {
            alert('Email sucessfully sent!');
        })
    }

    failRegister(registerError) {
        this.dispatch({registerError});
    }

    changeLanguage(theLanguage) {
        if (typeof window !== 'undefined') {
            new SingleObjectResource(DJ_CONST.API.apiUserLanguage).put(null, {language_code: theLanguage}).then(() => {
                window.location.reload();
            });
        }
    }
}

export default alt.createActions(CurrentUserActions);



/** WEBPACK FOOTER **
 ** ./app/src/actions/CurrentUserActions.js
 **/